import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Calendar, ThermometerSun, PauseCircle, HeartHandshake } from 'lucide-react';
export const WhatYouGet = () => {
  const items = [{
    icon: <BookOpen className="w-6 h-6" data-id="element-220" />,
    title: 'Ebook Maestro "El Método Sueño Profundo"',
    desc: '6 capítulos con la estrategia completa paso a paso.'
  }, {
    icon: <Calendar className="w-6 h-6" data-id="element-221" />,
    title: 'El Protocolo de las 72 Horas',
    desc: 'La hoja de ruta exacta de qué hacer cada día y cada noche para resetear el reloj biológico.'
  }, {
    icon: <ThermometerSun className="w-6 h-6" data-id="element-222" />,
    title: 'Guía de la Cueva del Sueño',
    desc: 'Cómo configurar la habitación (luz, sonido rosa y temperatura) para el éxito total.'
  }, {
    icon: <PauseCircle className="w-6 h-6" data-id="element-223" />,
    title: 'Técnica de la Pausa de 5 Minutos',
    desc: 'El secreto para que tu bebé aprenda a conectar ciclos de sueño sin que tú tengas que intervenir.'
  }, {
    icon: <HeartHandshake className="w-6 h-6" data-id="element-224" />,
    title: 'Plan de Rescate para la Madre',
    desc: 'Estrategias reales para que tú también vuelvas a dormir 4 o 5 horas seguidas desde la primera noche.'
  }];
  return <section className="py-20 px-6 bg-white" data-id="element-225">
      <div className="max-w-4xl mx-auto" data-id="element-226">
        <div className="mb-16" data-id="element-227">
          <img src="https://cdn.magicpatterns.com/uploads/dhNu58UK6uDnu41T8cea6F/LP6.png" alt="La Infografía del Cortisol - La Ventana de 90 Minutos: fases del bebé desde alerta hasta cortisol disparado" className="w-full max-w-2xl mx-auto rounded-2xl shadow-lg mb-12" data-id="element-228" />
        </div>
        <div className="text-center mb-16" data-id="element-229">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-navy mb-4" data-id="element-230">
            Todo lo que incluye el programa
          </h2>
          <p className="text-lg text-brand-charcoal/70 mb-10" data-id="element-231">
            Un sistema completo diseñado para resultados rápidos.
          </p>
          <img src="https://cdn.magicpatterns.com/uploads/kDbuyhjFbbnjm66oUELsxE/LP02.png" alt="Sueño Sereno - Madre con bebé usando el método en laptop, tablet y celular" className="w-full max-w-2xl mx-auto rounded-2xl shadow-lg" data-id="element-232" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-233">
          {items.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className={`p-6 rounded-2xl border border-brand-lavender/20 bg-brand-cream/50 hover:bg-brand-cream transition-colors ${i === 4 ? 'md:col-span-2 md:w-1/2 md:mx-auto' : ''}`} data-id="element-234">
              <div className="w-12 h-12 bg-brand-lavender/10 text-brand-lavender rounded-xl flex items-center justify-center mb-4" data-id="element-235">
                {item.icon}
              </div>
              <h3 className="text-xl font-bold text-brand-navy mb-2" data-id="element-236">
                {item.title}
              </h3>
              <p className="text-brand-charcoal/80" data-id="element-237">{item.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};